<template>
  <section class="closefriend-hero settings-page">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <customer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></customer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header -->
          <div class="mb-4 mt-2 px-1">
            <h5 class="text-white font-weight-700 mb-0 font-size-20">Account Settings</h5>
            <span class="text-muted font-size-12">Manage profile & connected handles</span>
          </div>
          
          <div class="row">
            <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">

            <div class="premium-settings-card mb-5 mt-2">
              <global-message class="mb-3"></global-message>

              <div class="row">
                <div class="col-12 mb-4">
                  <label class="premium-label">Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control premium-input" placeholder="Example: Adam" v-model="user.name">
                  <span class="error invalid-feedback d-block mt-1" v-if="isRequired('name')">This is required field</span>
                </div>

                <div class="col-12 mb-4" v-for="(customerPlatform, index) in user.customerPlatforms" :key="index">
                  <label class="premium-label">{{ customerPlatform.platform.name }} Handle <span class="text-danger">*</span></label>
                  <input type="text" class="form-control premium-input"
                    placeholder="Example: myhandle" v-model="handles[index].handle">
                  <span class="error invalid-feedback d-block mt-1" v-if="isSubmit && !$v.handles.$each[index].handle.required">This is required field</span>
                </div>

                <div class="col-12 mb-4">
                  <label class="premium-label">Email <span class="text-danger">*</span></label>
                  <input type="text" class="form-control premium-input"
                    placeholder="Example: myemail@com" v-model="user.email" readonly>
                  <span class="error invalid-feedback d-block mt-1" v-if="isRequired('email')">This is required field</span>
                  <span class="error invalid-feedback d-block mt-1" v-if="isValidEmail()">Not a valid email address</span>
                </div>

                <div class="col-12 col-md-6 mb-4">
                  <label class="premium-label">Password <span class="text-danger">*</span></label>
                  <input type="password" class="form-control premium-input"
                    placeholder="Update password" v-model.lazy="pwd">
                  <span class="error invalid-feedback d-block mt-1" v-if="isSubmit && !$v.pwd.required">This is required field</span>
                </div>

                <div class="col-12 col-md-6 mb-4">
                  <label class="premium-label">Repeat Password <span class="text-danger">*</span></label>
                  <input type="password" class="form-control premium-input"
                    placeholder="Re-enter new password" v-model="repeatPassword">
                  <span class="error invalid-feedback d-block mt-1" v-if="isSubmit && !$v.repeatPassword.required">This is required field</span>
                  <span class="error invalid-feedback d-block mt-1" v-else-if="isSubmit && !$v.repeatPassword.sameAs">Passwords must match</span>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="save()">
                  <i class="fa fa-check me-2 font-size-12"></i> Save
                </button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    </div>
  </section>
</template>

<script>

import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import {email, required, sameAs} from "vuelidate/lib/validators";
import {BASE_URL} from '@/properties/close-friend';
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import CustomerMenu from "@/components/module/customer/shared/CustomerMenu";
import {SERVICE_IDENTIY} from "@/properties/micro-service";

import {igValidationMixin} from "@/mixin/ig-validation-mixin";
import CustomerPwaActionBar from "@/components/module/customer/shared/CustomerPwaActionBar";
import LoadingModal from "@/components/module/shared/LoadingModal";
import titleMixin from "../../../mixin/title-mixin";

export default {
  name: 'CustomerSettings',
  title: 'Customer settings',
  mixins: [igValidationMixin, titleMixin],
  components: {HeaderMenu, CustomerMenu,
    GlobalMessage, CustomerPwaActionBar, LoadingModal},
  data() {
    return {
      user: {},
      handles: [],
      repeatPassword: null,
      showSlideBar: false,
      pwd: null,
      BASE_URL,
      isSubmit: false,
    }
  },
  validations() {
    return {
      user: {
        name: {required},
        email: {required, email},
      },
      repeatPassword: {
        required, sameAs: sameAs(function () {
          return this.pwd;
        })
      },
      pwd: {
        required
      },
      handles: {
        required,
        $each: {
          handle: {required}
        }
      }
    }
  },
  created() {
    this.initIGValidity();
    this.user = this.getUser();
    this.user.customerPlatforms.forEach((customerPlatform) => {
      this.handles.push({handle: customerPlatform.handle, customerPlatformId: customerPlatform.id});
    });
  },
  methods: {
    isRequired(attrib) {
      return this.isSubmit && !this.$v.user[attrib].required;
    },
    isValidEmail() {
      return this.isSubmit && !this.$v.user.email.email;
    },
    save() {
      this.isSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.user.password = this.pwd;
      this.patchData(`${SERVICE_IDENTIY}/api/v1/customers/${this.user.id}`, this.user, (data) => {
        this.user = data;
        this.pwd = null;
        this.repeatPassword = null;
        this.isSubmit = false;
        this.setUser(data);

        let url = `${SERVICE_IDENTIY}/api/v1/customers/${this.user.id}/customer-platform/`
        this.handles.forEach((handle) => {
          this.patchData(`${url}${handle.customerPlatformId}`, {handle: handle.handle}, (data) => {
            this.setMessage('SAVED.SUCCESSFULLY');
          });
        })
      });
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    }
  }
}
;
</script>

<style scoped>


.premium-settings-card {
  background: rgba(20, 20, 20, 0.6);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  padding: 40px;
  position: relative;
  overflow: hidden;
}

.premium-settings-card::before {
  content: '';
  position: absolute;
  top: -100px;
  right: -100px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(229, 59, 185, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

.premium-title {
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(135deg, #ffffff 0%, #a0a0a0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 32px;
  text-align: center;
  letter-spacing: -0.5px;
  position: relative;
  z-index: 1;
}

.premium-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 8px;
  display: block;
  position: relative;
  z-index: 1;
}

.premium-input {
  background: rgba(0, 0, 0, 0.4) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
  border-radius: 14px;
  padding: 14px 20px;
  height: 54px;
  font-size: 15px;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
}

.premium-input:focus {
  background: rgba(0, 0, 0, 0.6) !important;
  border-color: #E53BB9 !important;
  box-shadow: 0 0 0 1px #E53BB9, 0 8px 16px rgba(229, 59, 185, 0.15) !important;
  outline: none;
}

.premium-input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
</style>
